module.exports = __webpack_public_path__ + "assets/a20a7423db93ec8f1cd1e404c5f6439b.mp3";